<template>
  <div class="add-category public-content">
    <div class="breadcrumb" style="background: #fff">添加分类</div>
    <div class="order-detail-basic">
      <el-form :model="categoryVo" label-width="140px">
        <el-form-item label="上级分类：">{{ parentDetail.categoryName }}</el-form-item>
        <el-form-item label="分类名称：">
          <el-input v-model="categoryVo.categoryName" ref="iptRef"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button round type="primary" @click="checkRepeat">确定</el-button>
    </div>
  </div>
</template>

<script>
import { categoryGet, categoryUsable, categoryAdd } from '@/api/pms'
export default {
  name: 'add-category',
  data () {
    return {
      parentDetail: JSON.parse(this.$route.query.detail),
      categoryVo: {
        categoryName: '',
        level: JSON.parse(this.$route.query.detail).level + 1,
        parentId: JSON.parse(this.$route.query.detail).id
      }
    }
  },
  created () {
    ;
  },
  methods: {
    // 检查重复
    checkRepeat () {
      let _this = this
      let name = {
        name: this.categoryVo.categoryName
      }
      categoryUsable(name).then((res) => {
        if (res.data.code === -1) {
          this.$message({
            type: 'error',
            message: '产品类重复'
          })
          this.$refs.iptRef.focus()
        } else if (res.data.success) {
          _this.onSubmit()
        } else {

        }
      })
    },
    onSubmit () {
      categoryAdd(this.categoryVo).then((res) => {
        if (res.data.success) {
          this.$message.success('添加产品类成功')
          this.$router.push('./procategory')
        } else {

        }
      })
    }
  }
}
</script>

<style scoped lang="less">
@deep: ~">>>";
.add-category {
  .attr-set {
    @{deep} .el-form-item__content {
      display: flex;

      .el-checkbox {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
